import ReactBootstrapSlider from 'react-bootstrap-slider';
import { useController } from 'react-hook-form';

interface SliderControlledProps {
  name: any;
  rules: any;
  step: number;
  min: number;
  max: number;
  defaultValue: number;
  showTooltip?: boolean;
}

function SliderControlled({ name, rules, step, min, max, defaultValue, showTooltip = true }: SliderControlledProps) {
  const { field } = useController({ name, rules, defaultValue });
  return (
    <ReactBootstrapSlider
      css={{ width: '100%' }}
      value={field.value}
      step={step}
      min={min}
      max={max}
      slideStop={field.onChange}
      tooltip={showTooltip ? "show" : "hide"}
      tooltipPosition="top"
    />
  );
}
export default SliderControlled;
